/**
 * @generated SignedSource<<bc8d07ebb2c90ea3c8d6746dcbd5028d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UnsupportedChainContent_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"WithWalletConnectionEnsuredModalBase_viewer">;
  readonly " $fragmentType": "UnsupportedChainContent_viewer";
};
export type UnsupportedChainContent_viewer$key = {
  readonly " $data"?: UnsupportedChainContent_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"UnsupportedChainContent_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UnsupportedChainContent_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WithWalletConnectionEnsuredModalBase_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "b70f262d8b244ff51683ac1d20ba8f29";

export default node;
